import { combineReducers } from "redux";
import { auth } from "./auth.reducer";
import config from "./config";
import { domainReducer } from "./domainReducer";

const rootReducer = combineReducers({
  config,
  auth,
  domain: domainReducer,
});

export default rootReducer;
